export default __webpack_public_path__ + "static/all-in-one-mobile-be14f75e9c2bb358013094ad237a12d2.svg";